import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 14 14",
  class: "yb-svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { id: "blank-notepad--content-notes-book-notepad-notebook" }, [
      _createElementVNode("path", {
        id: "Union",
        fill: "currentColor",
        "fill-rule": "evenodd",
        d: "M4.30859 2.10437C5.05038 2.04703 5.72179 2.01425 6.25 1.99801L6.25 0.915039C6.25 0.500826 6.58579 0.165039 7 0.165039C7.41421 0.165039 7.75 0.500825 7.75 0.915039L7.75 1.998C8.2782 2.01424 8.94961 2.04702 9.69141 2.10437V0.915039C9.69141 0.500826 10.0272 0.165039 10.4414 0.165039C10.8556 0.165039 11.1914 0.500825 11.1914 0.915039V2.28056C12.5079 2.61552 13.4985 3.73898 13.6173 5.13691C13.7187 6.32958 13.75 7.41514 13.75 7.91111C13.75 8.40701 13.7187 9.49135 13.6174 10.6831C13.4845 12.2461 12.2617 13.466 10.7122 13.6243C9.1224 13.7866 7.68706 13.835 7.00003 13.835C6.31301 13.835 4.87767 13.7866 3.28787 13.6243C1.73834 13.466 0.515581 12.2461 0.382648 10.6831C0.281291 9.49137 0.25 8.40702 0.25 7.91111C0.25 7.41512 0.281302 6.32956 0.382704 5.1369C0.501555 3.73901 1.49214 2.61557 2.80859 2.28058L2.80859 0.915039C2.80859 0.500826 3.14438 0.165039 3.55859 0.165039C3.97281 0.165039 4.30859 0.500825 4.30859 0.915039L4.30859 2.10437Z",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])))
}
export default { render: render }